import { render, staticRenderFns } from "./updateInfoFeedback.vue?vue&type=template&id=7abccb74&scoped=true&"
import script from "./updateInfoFeedback.vue?vue&type=script&lang=js&"
export * from "./updateInfoFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abccb74",
  null
  
)

export default component.exports